document.addEventListener('DOMContentLoaded', function () {
  var savedScrollY = 0;

  document.querySelectorAll('[data-size-chart-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var context = trigger.closest('[data-size-chart-context]') || document;
      var modal = context.querySelector('[data-size-chart-modal]');
      if (modal) openDrawer(modal);
    });
  });

  document.querySelectorAll('[data-size-chart-modal]').forEach(function (modal) {
    modal.querySelectorAll('[data-size-chart-close]').forEach(function (closeEl) {
      closeEl.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer(modal);
      });
    });

    var toggle = modal.querySelector('[data-size-chart-unit-toggle]');
    if (toggle) {
      toggle.querySelectorAll('.size-chart-unit-toggle__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setUnit(modal, btn.dataset.unit);
          toggle.querySelectorAll('.size-chart-unit-toggle__option').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        });
      });
    }
  });

  // Single delegated Escape-key listener, no per-modal duplication.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-size-chart-modal].is-open').forEach(closeDrawer);
  });

  function openDrawer(modal) {
    savedScrollY = window.scrollY;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-chart-open');
    document.body.style.top = '-' + savedScrollY + 'px';
  }

  function closeDrawer(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-chart-open');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
  }

  function setUnit(modal, unit) {
    var tables = modal.querySelectorAll('[data-size-chart-table]');
    if (!tables.length) return;

    tables.forEach(function (table) {
      table.querySelectorAll('td[data-cm]').forEach(function (cell) {
        var cmValue = cell.dataset.cm;
        cell.textContent = unit === 'cm' ? cmValue : convertRangeToInches(cmValue);
      });
    });
  }

  // Converts a "75-78" cm range string to inches, e.g. "29.5-30.7"
  function convertRangeToInches(range) {
    return range
      .split('-')
      .map(function (s) { return s.trim(); })
      .map(function (n) {
        var num = parseFloat(n);
        return isNaN(num) ? n : (num / 2.54).toFixed(1);
      })
      .join('-');
  }
});